import axios from "axios";
import { SERVER_PATH } from "../config/env";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: SERVER_PATH,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor (Attach Authorization Token)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Ensure same key
    const userId = localStorage.getItem("userId");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (userId) {
      config.headers["user"] = userId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor (Handle Unauthorized & Expired Token)
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       console.log("Unauthorized! Logging out...");
//       localStorage.removeItem("token"); // Match key from storage
//       localStorage.removeItem("userId");
//       window.location.href = "/login"; // Redirect to login page
//     }
//     return Promise.reject(error);
//   }
// );

export default apiClient;
